<template>
  <div class="modalTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="getRadioEvent">获取选中</el-button>
        <el-button type="primary" @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      auto-resize
      stripe
      highlight-current-row
      height="80%"
      :radio-config="{ highlight: true }"
      :data="tableData"
      align="center"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="upstreamCustomerName"
          title="客户名称"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.upstreamCustomerName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="classificationName"
          title="车型"
          min-width="100"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择车型"
            clearable
          >
            <el-option
              v-for="item in vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="upstreamCustomerPhone"
          title="实际承运人手机号"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.upstreamCustomerPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { UpstreamCustomer } from "@/api/orderform";
import { getListDict } from "@/api/commonApi";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      tableData: [],
      listQuery: {
        name: "",
        phone: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        coalType: "",
        shipperSubdivisionCode: "",
        consigneeSubdivisionCode: "",
        companyCode: "",
        weight: "",
        distance: "",
        branchCode: ""
      },
      Pagingconf: [],
      vehicleClassificationList: [],
      selectRecords: [] /* 
      shangcustomer: {
        shipperSubdivisionCode: '120101',
        consigneeSubdivisionCode: '110105',
        weight: 2,
        distance: 100
      } */
    };
  },
  created() {},
  methods: {
    designcar(f, branchCode) {
      this.listQuery.branchCode = branchCode;
      this.listQuery.coalType = f.coalType.join(",");
      this.listQuery.shipperSubdivisionCode = f.shipperSubdivisionCode.join(
        ","
      );
      this.listQuery.consigneeSubdivisionCode = f.consigneeSubdivisionCode.join(
        ","
      );
      this.listQuery.companyCode = f.shipmentCode;
      this.listQuery.weight = f.weight;
      this.listQuery.distance = f.distance;
      getListDict({
        types: "vehicleClassification",
        branchCode: branchCode
      }).then(response => {
        this.vehicleClassificationList = response.data.filter(
          item => item.type === "vehicleClassification"
        )[0]["dictList"];
        this.findList();
      });
    },
    findList() {
      UpstreamCustomer(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
      });
    },
    // 获取选中
    getRadioEvent() {
      this.getdata = this.$refs.xTable.getRadioRecord();
      if (this.getdata) {
        this.$emit("event4", this.getdata);
      } else {
        this.$message({ message: "请选择一个上游客户", type: "warning" });
      }
    }
  }
};
</script>

<style></style>
